<script>
  import { router, inertia } from '@inertiajs/svelte';
  import Icon from '@iconify/svelte';
  import AppLayout from '../../components/AppLayout.svelte';
  import Card from '../../components/ui/Card.svelte';
  import Button from '../../components/ui/Button.svelte';
  import ConfirmDialog from '../../components/ui/ConfirmDialog.svelte';
  import PlatformBadge from '../../components/ui/PlatformBadge.svelte';
  import StatusBadge from '../../components/StatusBadge.svelte';

  let { post } = $props();

  let confirmingDelete = $state(false);
  let deleteError = $state(null);

  function destroy() {
    deleteError = null;
    router.delete(`/posts/${post.id}`, {
      onError: () => { deleteError = 'Could not delete this post. Please try again.'; },
      onFinish: () => { confirmingDelete = false; },
    });
  }

  function fmt(t) {
    return t ? new Date(t).toLocaleString() : null;
  }
</script>

<AppLayout title="Post">
  <div class="flex items-center justify-between mb-6">
    <a use:inertia href="/posts" class="text-sm text-secondary-500 hover:text-primary-600 flex items-center gap-1">
      <Icon icon="mdi:arrow-left" /> Back to posts
    </a>
    <div class="flex items-center gap-3">
      <Button href={`/posts/${post.id}/reuse`}><Icon icon="mdi:content-copy" class="mr-1" /> Reuse</Button>
      <Button variant="danger" onclick={() => { confirmingDelete = true; }}><Icon icon="mdi:delete-outline" class="mr-1" /> Delete</Button>
    </div>
  </div>

  {#if deleteError}
    <div role="alert" class="rounded-xl border border-red-200 bg-red-50 text-red-700 px-4 py-3 mb-6 text-sm">
      {deleteError}
    </div>
  {/if}

  <ConfirmDialog
    open={confirmingDelete}
    title="Delete this post?"
    body="This can't be undone."
    confirmLabel="Delete"
    onconfirm={destroy}
    oncancel={() => { confirmingDelete = false; }}
  />

  <div class="max-w-2xl flex flex-col gap-6">
    <Card>
      <div class="flex items-center justify-between mb-4">
        <StatusBadge status={post.status} />
        <div class="text-xs text-secondary-400">
          {#if post.scheduled_at && post.status === 'scheduled'}
            Scheduled for {fmt(post.scheduled_at)}
          {:else if post.published_at}
            Published {fmt(post.published_at)}
          {:else}
            Created {fmt(post.created_at)}
          {/if}
        </div>
      </div>
      <p class="text-secondary-800 whitespace-pre-wrap">{post.body}</p>
      {#if post.media_count > 0}
        <div class="flex flex-wrap gap-2 mt-4">
          {#each post.media as m}
            <div class="relative w-24 h-24 rounded-lg overflow-hidden border border-secondary-200 bg-secondary-50">
              {#if m.url && !post.media_expired}
                <img src={m.url} alt="" class="w-full h-full object-cover" />
              {:else}
                <div class="w-full h-full flex items-center justify-center text-secondary-300">
                  <Icon icon={post.media_expired ? 'mdi:image-off-outline' : 'mdi:image-outline'} class="text-2xl" />
                </div>
              {/if}
            </div>
          {/each}
        </div>
      {/if}
    </Card>

    <Card title="Delivery">
      <ul class="flex flex-col divide-y divide-secondary-100">
        {#each post.targets as t}
          <li class="flex items-center justify-between py-3 first:pt-0 last:pb-0">
            <div class="text-sm"><PlatformBadge platform={t.platform} handle={t.handle} /></div>
            <div class="flex items-center gap-3">
              {#if t.error_message}
                <span class="text-xs text-red-600" title={t.error_message}>{t.error_message}</span>
              {/if}
              <StatusBadge status={t.status} />
            </div>
          </li>
        {/each}
      </ul>
    </Card>
  </div>
</AppLayout>
